/**
 * The RewardsCalculator component is used to render the RewardsCalculator iframe within the context of the ulta domain.
 * @module views/components/RewardsCalculator
 * @memberof -Common
 */
import './RewardsCalculator.scss';

import React, { useEffect, useRef, useState } from 'react';

import IframeResizer from 'iframe-resizer-react';
import PropTypes from 'prop-types';

import * as iframedContent from '@ulta/core/components/IframedContent/IframedContent';
import { useAppConfigContext } from '@ulta/core/providers/AppConfigProvider/AppConfigProvider';

/**
  * Represents a RewardsCalculator component
  *
  * @method
  * @param {RewardsCalculatorProps} props - React properties passed from composition
  * @returns RewardsCalculator
  */
export const RewardsCalculator = function( props ){
  const { isLocal } = useAppConfigContext();
  const [iframeSrc, setIframeSrc] = useState();
  const {
    contentUrl
  } = props;

  let iframeRef = useRef();

  const [iframeContentLoaded, setIframeContentLoaded] = useState( false );
  const [iframeNoScriptMarkup, setIframeNoScriptMarkup] = useState( );

  useEffect( ()=> {
    iframedContent.handleIframeContent( { iframeSrc, iframeRef, iframeContentLoaded }, { setIframeNoScriptMarkup } );
  }, [iframeRef.current, iframeContentLoaded] );

  useEffect( ()=> {
    iframedContent.isUltaDomain( { contentUrl, isLocal }, { setIframeSrc } );
  }, [] );

  return (
    <div
      ref={ iframeRef }
      className='RewardsCalculator'
    >
      { iframeSrc &&
      <>
        <IframeResizer
          onLoad={ iframedContent.handleIframeLoaded( { setIframeContentLoaded } ) }
          src={ iframeSrc }
          autoResize={ true }
          heightCalculationMethod='lowestElement'
          title={ contentUrl }
          scrolling={ true }
        />
        { iframeNoScriptMarkup &&
        <noscript>
          { iframeNoScriptMarkup }
        </noscript>
        }
      </>
      }
    </div>
  );
};

/**
  * Property type definitions
  * @typedef RewardsCalculatorProps
  * @type {object}
  * @property {string} contentUrl - The URL of the iframe content
  */
export const propTypes =  {
  contentUrl: PropTypes.string
};

RewardsCalculator.propTypes = propTypes;

export default RewardsCalculator;
